import React from 'react'
import { Link, graphql } from 'gatsby'
import Img from 'gatsby-image'
//import MediaQuery from 'react-responsive'

import Layout from            '../components/layout'
import BlogPostPreview from  '../components/BlogPostPreview'
import toTitleCase from       '../utils/toTitleCase'

const HeroSection = ({ post }) => {
  return (
    <div>
      <div className="hero-lg">
        <div className="mx-auto mb-5" style={{ width: '500px' }}>
          <div className="media">
            { post.node.data.image ? (
              <Img
                className="align-self-start mr-3 rounded"
                fixed={post.node.data.image.localFile.childImageSharp.fixed} />
            ) : null }
            <div className="media-body" style={{ height: '250px' }}>
              <div style={{ position: 'relative', top: '50%', transform: 'translateY(-50%)' }}>
                <h3 className="mb-2 mt-0">Hello</h3>
                <h1 className="mt-2 mb-2">I am Ryan Shea</h1>
                <h3 className="mt-2 mb-2">Welcome to my blog</h3>
                <div className="mt-3 mb-0">
                  <Link to='/about' className="btn btn-outline-secondary">About Me</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-sm">
        <div style={{ width: '100%' }}>
          <div style={{ width: '250px' }} className="mx-auto mb-5">
            { post.node.data.image ? (
              <Img
                className="rounded mb-3"
                fixed={post.node.data.image.localFile.childImageSharp.fixed} />
            ) : null }
            <h3 className="mb-2 mt-0">Hello</h3>
            <h1 className="mt-2 mb-2">I am Ryan Shea</h1>
            <h3 className="mt-2 mb-2">Welcome to my blog</h3>
            <div className="mt-3 mb-0">
              <Link to='/about' className="btn btn-outline-secondary">About Me</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const ArticleColumn = ({ title, posts, tags }) => (
  <div className="mb-5">
    <div>
      <h2 className="mt-0">{title}</h2>
      { posts.map((postEdge, index) => {
        const post = postEdge.node
        return (
          <div key={index} className="mb-3">
            <BlogPostPreview
              key={post.id}
              path={`/${post.uid}`}
              title={post.data.title.text}
              excerpt={post.data.content.text.substring(0, 140)}
              date={post.data.date}
              fixedImage={post.data.image.localFile.childImageSharp.fixed}
            />
          </div>
        )
      })}
      <p>
        {tags.map((tag, index) => {
          return (
            <Link key={index} to={`/category/${tag}`}
                  className="btn btn-outline-secondary"
                  style={{ marginRight: '5px' }}>
              View All {toTitleCase(tag.replace('my-', '').replace('-', ' '))}
            </Link>
          )
        })}
      </p>
    </div>
  </div>
)

const IndexPage = ({ data: { allPrismicPost } }) => {
  const { edges } = allPrismicPost
  const posts = edges.filter(edge => !!edge.node.data.date)
  const sections = [
    {tags: ['startups'], title: 'Startups'},
    {tags: ['books'], title: 'Books'},
    {tags: ['talks'], title: 'Talks'},
    {tags: ['philosophy'], title: 'Philosophy'},
    {tags: ['blockchain', 'finance'], title: 'Blockchain & Finance'},
    {tags: ['healthcare', 'biology'], title: 'Bio & Healthcare'},
  ]
  const aboutPost = posts.filter(edge => 
    edge.node.data.categories.map(category => category.category.uid)
    .includes('about')
  ).slice(0,1)[0]

  return (
    <Layout>
      <HeroSection post={aboutPost} />
      <div className="container">
        <div className="row">
        {sections.map(function(section, index) {
          const sectionPosts = posts.filter(edge =>
            edge.node.data.categories.map(category => category.category.uid).some(
              categoryUID => section.tags.includes(categoryUID)
            )
          )
          return (
            <div key={index}
                className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
              <ArticleColumn posts={sectionPosts.slice(0,2)}
                title={section.title} tags={section.tags} />
            </div>
          )
        })}
        </div>
      </div>
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query {
    allPrismicCategory(
      sort: { order: DESC, fields: [uid] }
    ) {
      edges {
        node {
          uid,
          data {
            name
          }
        }
      }
    }

    allPrismicPost(
      sort: { order: DESC, fields: [data___date] }
    ) {
      edges {
        node {
          id
          uid
          data {
            date(formatString: "MMMM DD, YYYY")
            title {
              html
              text
            }
            content {
              html
              text
            }
            image {
              localFile {
                childImageSharp {
                  fluid(maxWidth: 800) {
                    ...GatsbyImageSharpFluid
                  }
                  fixed(width: 250, height: 250) {
                    ...GatsbyImageSharpFixed
                  }
                }
              }
            }
            categories {
              category {
                uid
              }
            }
          }
        }
      }
    }
  }
`